import * as AllColors from "../../../constants/colors";
import { BackgroundColor } from "../../background/constants/background-types";
import { createButtonMapDefinition } from "../../../utils/scheme-helper";
import { ButtonSchemeConfiguration } from "../../../constants/colors";
import { ButtonSchemeDefinition } from "./button-types";
import { toConstantCase } from "../../../utils/string-format";

export const TARGET_BLANK = "_blank";
export const TARGET_SELF = "_self";
export const TARGET_PARENT = "_parent";
export const TARGET_TOP = "_top";
export const BUTTON_TARGETS = [TARGET_BLANK, TARGET_SELF, TARGET_PARENT, TARGET_TOP] as const;

export const BUTTONRANK_PRIMARY = "primary";
export const BUTTONRANK_SECONDARY = "secondary";
export const BUTTONRANK_FUNCTIONAL = "functional";
export const BUTTONRANK_DISCREET = "discreet";

export const BUTTON_RANKS = [
  BUTTONRANK_PRIMARY,
  BUTTONRANK_SECONDARY,
  BUTTONRANK_FUNCTIONAL,
  BUTTONRANK_DISCREET
] as const;

export const BUTTONSIZE_LARGE = "large";
export const BUTTONSIZE_NORMAL = "normal";
export const BUTTONSIZE_SMALL = "small";

export const BUTTON_SIZES = [BUTTONSIZE_NORMAL, BUTTONSIZE_SMALL, BUTTONSIZE_LARGE] as const;

export const BUTTONTYPE_BUTTON = "button";
export const BUTTONTYPE_RESET = "reset";
export const BUTTONTYPE_SUBMIT = "submit";

export const BUTTON_TYPES = [BUTTONTYPE_BUTTON, BUTTONTYPE_RESET, BUTTONTYPE_SUBMIT] as const;

export const BUTTONSHAPE_TEXT = "text";
export const BUTTONSHAPE_ICON = "icon";
export const BUTTONSHAPE_TEXTANDICON = "text-and-icon";

export const BUTTON_SHAPES = [BUTTONSHAPE_TEXT, BUTTONSHAPE_ICON, BUTTONSHAPE_TEXTANDICON] as const;

function createSchemes() {
  let newSchemes: ButtonSchemeConfiguration<ButtonSchemeDefinition> = {};

  AllColors.BUTTON_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      primaryBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      primaryBackgroundHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      primaryBackgroundFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      primaryBackgroundDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      primaryTextAndIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      primaryTextAndIconHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      primaryTextAndIconFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      primaryTextAndIconDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      primaryBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      primaryBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      primaryBorderFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      primaryBorderDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      primaryFocusOutlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],

      secondaryBackgroundColor: AllColors.COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      secondaryBackgroundFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      secondaryBackgroundDisabledColor: AllColors.COLOR_TRANSPARENT,
      secondaryTextAndIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      secondaryTextAndIconHoverColor: AllColors.COLOR_BRIGHT,
      secondaryTextAndIconFocusColor: AllColors.COLOR_BRIGHT,
      secondaryTextAndIconDisabledColor: AllColors.COLOR_BRIGHT,
      secondaryBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      secondaryBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      secondaryBorderFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      secondaryBorderDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      secondaryFocusOutlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],

      functionalBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      functionalBackgroundHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      functionalBackgroundFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      functionalBackgroundDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      functionalTextAndIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      functionalTextAndIconHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      functionalTextAndIconFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      functionalTextAndIconDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      functionalBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      functionalBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      functionalBorderFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      functionalBorderDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_60`],
      functionalFocusOutlineColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],

      discreetBackgroundColor: AllColors.COLOR_TRANSPARENT,
      discreetBackgroundHoverColor: AllColors.COLOR_TRANSPARENT,
      discreetBackgroundFocusColor: AllColors.COLOR_TRANSPARENT,
      discreetBackgroundDisabledColor: AllColors.COLOR_TRANSPARENT,
      discreetTextAndIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      discreetTextAndIconHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      discreetTextAndIconFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      discreetTextAndIconDisabledColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      discreetBorderColor: AllColors.COLOR_TRANSPARENT,
      discreetBorderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      discreetBorderFocusColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      discreetBorderDisabledColor: AllColors.COLOR_TRANSPARENT
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const BUTTON_SCHEME_CONFIG: AllColors.ButtonSchemeConfiguration<ButtonSchemeDefinition> = createSchemes();

export const BUTTON_SCHEME_MAP: Map<BackgroundColor | "default", ButtonSchemeDefinition> = new Map(
  Object.entries(createButtonMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    BUTTON_SCHEME_CONFIG[config as string]
  ])
);
